import React, { useMemo } from 'react'
import { ContainerField, Container } from '@sencha/ext-modern'
import _ from 'lodash'
import { getListFromValues, addListItem, changeListItem, deleteListItem } from 'tyan/public/utility'
import { genFullListName, getMixedProps } from '../blockPublic'
import Attachment from './Attachment'
// export const genFileText = (name, size)...
// export const handleImageTap = (title, target)...
import { genFileText } from '.'
import AddFiles from './AddFiles'
import RenameFile from './RenameFile'
import { useEventHandler } from '../../../../hooks'
import { showContextMenu } from '../../../column/contextmenu'
import { getDownloadUrl } from './fileRealServe'

const WrapImages = ({ children, layout, ...props }) => (
	<Container {...props} layout={{ type: 'hbox', wrap: 'true', pack: 'center', ...layout }}>
		{children}
	</Container>
)

const WrapAttachments = ({ children, layout, ...props }) => (
	<Container {...props} layout='vbox'>
		{children}
	</Container>
)

const Files = ({ field, initValues, changedValues, defaultStyle, that }) => {
	const { props: { key, margin,
		disabled, imageSize: imageSizeProp, param, accept, unacceptableFiles, maxSize, multiple, limit,
		disableDelete, disableRename, disableUpload, disableEdit, onChange: onCustomChange,
		enableCapture, editNewImage, enableJoyusingV1, sortField, expansion, editFields,
		rotatable, showUploadPerson, showUploadTime, downloadAll: downloadAllProp,
		layout,
		...filesProps } } = getMixedProps('_files', [defaultStyle, field])

	const { _fieldsetName: fieldsetName, name: fieldNamePar, list: listConf, EditComp = RenameFile } = field
	const imageSize = imageSizeProp
		&& (!Array.isArray(imageSizeProp) ? { width: imageSizeProp, height: imageSizeProp } : { width: imageSizeProp[0], height: imageSizeProp[1] })
		|| null

	const downloadAll = downloadAllProp || filesProps.label || fieldNamePar

	const fieldName = genFullListName(listConf, fieldNamePar)
	let filesInputAccept = accept || imageSize && 'image/*'
	filesInputAccept && (filesInputAccept = filesInputAccept.toLowerCase())
	const { list: values } = getListFromValues(fieldName, initValues, changedValues, [], sortField)
	const valuesCount = values.length
	const remain = (multiple ? (limit ? limit : Infinity) : 1) - valuesCount
	const required = filesProps.required && !valuesCount

	const handleAddValue = value => {
		addListItem(that, value, fieldsetName, fieldName, undefined, sortField)
		onCustomChange && onCustomChange()
	}

	const handleChangeValue = (value, changedValues) => {
		changedValues = { ...changedValues }
		changedValues.FileName && (changedValues.Text = genFileText(changedValues.FileName, value.FileExt, value.FileSize))
		// console.log('changedValues:', changedValues)
		changeListItem(that, changedValues, {}, fieldsetName, fieldName, value.id, sortField)
		onCustomChange && onCustomChange()
	}

	const handleRemoveValue = value => {
		deleteListItem(that, fieldsetName, fieldName, value.id), [that, fieldsetName, fieldsetName]
		onCustomChange && onCustomChange()
	}

	const handleSortValue = (value, isUp) => {
		let { id, [sortField]: sortValue } = value
		sortValue += isUp ? -1 : 1
		// console.log('sortValues:', value[sortField], sortValue)
		changeListItem(that, { [sortField]: sortValue }, {}, fieldsetName, fieldName, id, sortField)
		onCustomChange && onCustomChange()
	}

	const handleRotate = (value, angle) => {
		const { id, FID, FileName, FileExt } = value
		// console.log('para:', FID, angle)
		Tyan.doPostEvent('RotatePicFile', {
			data: { FID, value: angle },
			onEnd: ({ errorMessage, FID, FileSize }) => {
				if (errorMessage) {
					Ext.toast(errorMessage)
				} else {
					// console.log('return:', FID, FileSize)
					changeListItem(that, { FID, FileSize, Text: genFileText(FileName, FileExt, FileSize) }, {}, fieldsetName, fieldName, id, sortField)
					onCustomChange && onCustomChange()
				}
			}
		})
	}
	const handleDownloadAll = () => {
		// 导出所有文件
		window.open(getDownloadUrl(values, downloadAll))
		// console.log('export All:', getDownloadUrl(values, downloadAll))
	}

	const handleContextMenu = useEventHandler(e => {
		if (values.length <= 2) return
		e.stopEvent()
		showContextMenu(e.getXY(), [
			{ text: '下载所有文件', ui: 'action', handler: handleDownloadAll },
		])
	})

	const listeners = useMemo(() => ({
		contextmenu: { element: 'bodyElement', fn: handleContextMenu },
		longpress: { element: 'bodyElement', fn: handleContextMenu }
	}), [])


	const Wrap = imageSize ? WrapImages : WrapAttachments
	// 如果是图片+required+disabled，显示空位
	return <ContainerField layout="vbox" margin={margin} /* defaults={{ margin }} */ {...filesProps}>
		<Wrap errorTarget={undefined} flex={1} listeners={listeners} layout={layout}>
			{values.map((value, index) => (
				<Attachment {...{
					key: `${value.id}_${value.FID}`, value, imageSize, param, remain, valuesCount,
					disabled, disableDelete, disableRename, disableEdit,
					onChangeValue: handleChangeValue,
					sortField, expansion, editFields, EditComp,
					onRemoveValue: handleRemoveValue,
					isFirst: index === 0, isLast: index === values.length - 1, onSortValue: handleSortValue,
					rotatable, onRotate: handleRotate, showUploadPerson, showUploadTime
				}} />
			))}
			{imageSize && disabled && !valuesCount && <Container layout='center' margin='5'>
				<Container {...imageSize} layout='center'
					style={{ fontFamily: 'FontAwesome', fontSize: `${Math.min(imageSize.width, imageSize.height) - 18}px`, color: 'lightgrey' }}
				>
					{'\uf03e'}
				</Container>
			</Container>}
			<AddFiles {...{
				disabled, disableUpload, imageSize, param, remain, valuesCount, required, accept: filesInputAccept, unacceptableFiles, maxSize, onAddValue: handleAddValue,
				enableCapture, editNewImage, enableJoyusingV1
			}} />
		</Wrap>
	</ContainerField >
}

export default Files
